import { toast, Flip } from "react-toastify";
import useTheme from "./useTheme";

const useNotification = () => {
	const { themeColor } = useTheme();

	const toastPreferences = {
		position: toast.POSITION.TOP_CENTER,
		autoClose: 500,
		transition: Flip,
		hideProgressBar: true,
		closeButton: false,
		style: { color: themeColor?.hex },
	};

	const notify = (type, message) => {
		switch (type) {
			case "success":
				toast.success(message, {
					...toastPreferences,
				});
				break;

			case "error":
				toast.error(message, {
					...toastPreferences,
				});
				break;
			case "warning":
				toast.warn(message, {
					...toastPreferences,
				});
				break;
			case "info":
				toast.info(message, {
					...toastPreferences,
				});
				break;

			default:
				toast(message, {
					...toastPreferences,
					className: "foo-bar",
				});
				break;
		}
	};

	return { notify };
};

export default useNotification;
